/** One Material Transfer Note, Processing's page (docs/designs/mtn-seed-indent.md). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { errMsg, useMtn } from "@/features/mtn/hooks";
import { MtnPage } from "@/features/mtn/mtn-page";

export const Route = createFileRoute("/_app/processing/mtn/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const q = useMtn(Number(id));
  const { facilities } = useFacilities();
  if (q.isPending) return <FormPageSkeleton />;
  if (q.isError)
    return (
      <Callout tone="danger" title="Could not load the note">
        {errMsg(q.error)}
      </Callout>
    );
  const plant = facilities.find((f) => f.id === q.data.facilityId);
  return (
    <MtnPage
      key={`${q.data.id}-${q.data.version}`}
      mtn={q.data}
      facilityId={q.data.facilityId}
      plantName={plant ? `${plant.name} (${plant.plantCode})` : null}
      audience="processing"
    />
  );
}
